<section class="auth-shell">
  <article class="auth-panel dbw-card dbw-card--xl">
    <p class="eyebrow">Authentification</p>
    <h2>Connexion impossible</h2>

    @if (authService.isReady()) {
      <dbw-state-card appearance="error">
        <p>La connexion n'a pas abouti. Vous pouvez relancer la connexion.</p>
      </dbw-state-card>
    } @else {
      <dbw-state-card appearance="loading">
        <p>Connexion en cours.</p>
      </dbw-state-card>
    }

    <div class="actions">
      <oui-button type="outlined" color="secondary" iconSuffix="login" [disabled]="!authService.isReady()" (click)="retryLogin()">
        Relancer la connexion
      </oui-button>
    </div>
  </article>
</section>
